// DEPRECATED
import React from 'react';
import { useTranslation } from 'react-i18next';
import TextTooltipOnHover from '../../Popover/Preset/TextTooltipOnHover';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import DSModal, {
  MODAL_FOOTER_BUTTON_SIZE,
  MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH,
} from '@wix/da-ds/pkg/modals/dsPresets/Modal';

import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { Props as ModalProps } from '../Modal';

export type Props = {
  title?: React.ReactNode;
  subtitle?: string;
  className?: string;
  isOpen?: boolean;
  children: React.ReactNode;
  shouldCloseOnOverlayClick?: boolean;
  bodyScrollLockOptions?: ModalProps['bodyScrollLockOptions'];
  useMobileFixedHeight?: ModalProps['useMobileFixedHeight'];
  showHeaderBorder?: boolean;
  showFooterBorder?: boolean;

  isLoading?: boolean;
  headerExtras?: React.ReactNode;
  footerExtras?: React.ReactNode;
  withCancelBtn?: boolean;
  cancelBtnLabel?: string;
  submitBtnLabel?: string;
  disabledSubmit?: boolean;
  disabledCancel?: boolean;
  submitTooltip?: React.ReactNode;
  submitBiData?: any;
  onSubmit?(e?): void;
  onCancel?(e?): void;
  onClose?(e?): void;
  innerScrollRef?: (node) => void;
};

const ModalFormDialog: React.FC<Props> = ({
  title,
  subtitle,
  children,
  headerExtras,
  footerExtras,
  className,
  isOpen,
  withCancelBtn = true,
  isLoading,
  cancelBtnLabel,
  submitBtnLabel,
  disabledSubmit,
  disabledCancel,
  submitTooltip,
  submitBiData,
  onSubmit,
  onCancel,
  onClose,

  showHeaderBorder,
  showFooterBorder,
  shouldCloseOnOverlayClick,
  bodyScrollLockOptions,
  useMobileFixedHeight,
  innerScrollRef,
}) => {
  const { t } = useTranslation();

  const renderFooter = () => {
    const submitButton = (
      <BrandedButton
        key="submit"
        size={MODAL_FOOTER_BUTTON_SIZE}
        style={{ minWidth: MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH }}
        variant="brand-green"
        onClick={onSubmit}
        disabled={disabledSubmit}
        biData={submitBiData}
      >
        {submitBtnLabel || t('popup.confirm')}
      </BrandedButton>
    );

    return [
      withCancelBtn && (
        <TextButton
          onClick={onCancel || onClose}
          disabled={disabledCancel}
          size="large"
          variant="main"
        >
          {cancelBtnLabel || t('popup.cancel')}
        </TextButton>
      ),
      disabledSubmit && submitTooltip && (
        <TextTooltipOnHover tooltipText={submitTooltip}>{submitButton}</TextTooltipOnHover>
      ),
      !(disabledSubmit && submitTooltip) && submitButton,
    ].filter(x => x);
  };

  return (
    <DSModal
      className={className}
      isOpen={isOpen ?? false}
      heading={title}
      subheading={subtitle}
      footerLeft={[footerExtras]}
      footerRight={renderFooter()}
      preamble={headerExtras}
      onRequestClose={onClose}
      useFixedMobileHeight={useMobileFixedHeight}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyScrollLockOptions={bodyScrollLockOptions}
      withScrollableContentWrapper={true}
      showHeaderBorder={showHeaderBorder}
      showFooterBorder={showFooterBorder}
      innerScrollRef={innerScrollRef}
    >
      {children}
      {isLoading && <LoadingIndicator />}
    </DSModal>
  );
};
ModalFormDialog.displayName = 'ModalFormDialog';

export default ModalFormDialog;
